import { Badge } from '@/components/UI';
import type { ColumnDef } from '@/components/UI/dataTableConfig';
import type { ScreenerOptimizerFeatureAnalysisRow } from '@/types/appRouter';
import { formatDecimal, formatPct01, toNumber } from './helpers';

export const featureAnalysisColumns: ColumnDef<ScreenerOptimizerFeatureAnalysisRow>[] = [
    {
        header: 'Rank',
        accessorKey: 'rank',
        size: 70
    },
    {
        header: 'Feature',
        accessorKey: 'featureKey',
        size: 250,
        cell: ({ row }) => <span className="text-white text-xs">{row.original.featureKey}</span>
    },
    {
        header: 'Operator',
        accessorKey: 'bestOperator',
        size: 80,
        cell: ({ row }) => <Badge variant="secondary">{row.original.bestOperator}</Badge>
    },
    {
        header: 'Threshold',
        accessorKey: 'bestThreshold',
        size: 120,
        cell: ({ row }) => <span className="text-white">{row.original.bestThreshold.toFixed(4)}</span>
    },
    {
        header: 'Sweet Score',
        accessorKey: 'bestSweetScore',
        size: 120,
        cell: ({ row }) => <span className="text-white">{formatDecimal(row.original.bestSweetScore, 4)}</span>
    },
    {
        header: 'Lift',
        accessorKey: 'bestLift',
        size: 100,
        cell: ({ row }) => {
            const value = toNumber(row.original.bestLift);
            const color = value >= 0 ? 'text-green-400' : 'text-red-400';
            return <span className={color}>{formatDecimal(row.original.bestLift, 2)}%</span>;
        }
    },
    {
        header: 'Trades',
        accessorKey: 'bestTradeCount',
        size: 80,
        cell: ({ row }) => <span className="text-white">{row.original.bestTradeCount.toLocaleString()}</span>
    },
    {
        header: 'WinRate',
        accessorKey: 'bestWinRate',
        size: 90,
        cell: ({ row }) => <span className="text-white">{formatPct01(row.original.bestWinRate, 1)}</span>
    },
    {
        header: 'Coverage',
        accessorKey: 'bestCoverage',
        size: 100,
        cell: ({ row }) => <span className="text-white">{formatPct01(row.original.bestCoverage, 1)}</span>
    },
    {
        header: 'Missing',
        accessorKey: 'missingRate',
        size: 90,
        cell: ({ row }) => <span className="text-zinc-300">{formatPct01(row.original.missingRate, 1)}</span>
    }
];
